import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CEREALES } from '../../../../config/tables'

export default function CerealesView () {
  return <MuiTable id={TABLA_CEREALES} />
}
